import React from "react";
import { TRUST } from "../data/content";

const LegalPage = ({ title, effective, intro, sections }) => (
  <div>
    <section className="bg-[#0F2942] py-14">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-white">{title}</h1>
        <p className="mt-3 text-slate-300 text-sm">Effective Date: {effective} · {TRUST.name}</p>
      </div>
    </section>
    <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <p className="text-slate-600 leading-relaxed mb-8">{intro}</p>
      <div className="space-y-7">
        {sections.map((s, i) => (
          <div key={i}>
            <h2 className="font-display text-lg font-bold text-slate-900">{i + 1}. {s.h}</h2>
            <p className="mt-2 text-slate-600 leading-relaxed text-sm">{s.p}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 bg-slate-50 border border-slate-200 rounded-xl p-6 text-sm text-slate-600">
        <p className="font-semibold text-slate-800 mb-2">Grievance & Contact Desk</p>
        <p>{TRUST.name}</p>
        <p>{TRUST.address}</p>
        <p>Email: {TRUST.email} · Ref: {TRUST.deedNo}</p>
      </div>
    </section>
  </div>
);

export default LegalPage;
